<template>
  <div id="thank-you-page">
    <div id="thank-you-msg" class="thank-you-msg">
      <span> Thank you for signing up {{ props.data.firstName }}! </span>
    </div>
    <div id="sign-up-contents">
      <p class="sign-up-msg">
        Your account is being processed. You should be recieving a <br />
        confirmation email shortly at:
      </p>
      <p class="email bold highlight">{{ props.data.email }}</p>
      <p class="sign-up-msg">If you do not receive an email in your email inbox, please check your spam / junk mail.</p>
      <p class="sign-up-msg">
        Please note that your confirmation email will <span class="highlight bold">expire within 2 days</span>.
      </p>
      <div id="visit-us">
        <span> In the meanwhile connect with us at: </span>
        <div class="visit-us-img">
          <a href="https://www.facebook.com/OperationSpringboard">
            <img class="social-media" :src="$assets.image['instagram_icon.png']" alt="instagram" />
          </a>
          <a href="https://twitter.com/OpSpringboard">
            <img :src="$assets.image['facebook_icon.png']" alt="facebook" />
          </a>
          <a href="http://www.thepicta.com/user/op.springboard/4789041783">
            <img :src="$assets.image['twitter_icon.png']" alt="twitter" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import $assets from '@/assets';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style>
#thank-you-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  padding: 2em 0;
  color: #fff;
  font-size: 1.2em;
}

#thank-you-page > div {
  text-align: center;
}

#sign-up-contents {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 2em;
  padding: 0 1em;
}

p.email {
  margin: 0 0 1em;
}

.thank-you-msg {
  font-size: 1.4em;
}

#visit-us {
  margin-top: 2em;
}

.visit-us-img {
  display: grid;
  grid-template-columns: repeat(3, 30%);
  justify-content: space-evenly;
  align-items: flex-start;
  margin-top: 1em;
}
.visit-us-img img {
  width: 3em;
}
.email {
  font-size: 1.2em;
}
.bold {
  font-weight: bold;
}

.highlight {
  color: #fff200;
}
</style>
